import React from "react";
import { Box, CircularProgress, IconButton, InputAdornment, TextField } from "@mui/material";
import ClearIcon from "@mui/icons-material/Clear";
import SearchIcon from "@mui/icons-material/Search";

export interface ComplianceRequirementsSearchBarProps {
  value: string;
  onChange: (value: string) => void;
  loading?: boolean;
  placeholder?: string;
}

export default function ComplianceRequirementsSearchBar({
  value,
  onChange,
  loading = false,
  placeholder = "Search requirements, CFR, documents…",
}: ComplianceRequirementsSearchBarProps) {
  return (
    <Box sx={{ width: "100%", marginBottom: "16px" }}>
      <TextField
        fullWidth
        size="small"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <SearchIcon sx={{ color: "#737373", fontSize: 20 }} />
            </InputAdornment>
          ),
          endAdornment: (
            <InputAdornment position="end">
              {loading ? (
                <CircularProgress size={18} sx={{ color: "#0a829d" }} />
              ) : value ? (
                <IconButton
                  size="small"
                  aria-label="Clear search"
                  onClick={() => onChange("")}
                  edge="end"
                >
                  <ClearIcon sx={{ fontSize: 18 }} />
                </IconButton>
              ) : null}
            </InputAdornment>
          ),
          sx: {
            fontFamily: "Rethink Sans, sans-serif",
            fontSize: "14px",
            backgroundColor: "#fff",
            borderRadius: "8px",
            "& fieldset": { borderColor: "#99d4e1" },
            "&:hover fieldset": { borderColor: "#35d7e4" },
            "&.Mui-focused fieldset": { borderColor: "#0a829d" },
          },
        }}
      />
    </Box>
  );
}
